import { FC, useEffect, useState } from 'react';
// @ts-ignore
import { client } from '../../../apollo';
import { ALL_PEOPLE, ALL_PEOPLE_ADMINPORTAL, ALL_STAKEHOLDER_TYPES, CREATE_STAKEHOLDERS } from '../../../graphql';
import { parseErrorMessage, stripSelectValues } from '../../../utils';

import { learnersFields, FieldType as FlatFileFieldType } from '../../../consts/flatfileFields';
import { Option } from '../../../utils/types';
import { Formik, FormikProps, FormikValues } from 'formik';
import { formatPeopleForBulkUpload } from '../../../utils/format';
import UploadPeopleModal from './UploadPeopleModal';
import TemplateModal from './TemplateModal';

interface Props {
  addStakeholderToOrganisation?: boolean;
  setShowUploadModal: (value: boolean) => void;
  showUploadModal: boolean;
  isAdminPortal: boolean;
  institutionId?: string;
}

type FormType = {
  ministryId: Option | undefined;
  typeId: Option | undefined;
  uploadData: any;
  fields: FlatFileFieldType[];
  updateOrNew: string;
};

const INITIAL_VALUES: FormType = {
  ministryId: undefined,
  typeId: undefined,
  uploadData: undefined,
  fields: [...learnersFields],
  updateOrNew: 'new',
};

const AdminPeopleBulkUpload: FC<Props> = props => {
  const [showPeopleOptionsModal, setShowPeopleOptionsModal] = useState(false);

  const [allStakeholderTypes, setAllStakeholderTypes] = useState<any[]>([]);

  const fetchStakeholderTypes = async () => {
    const {
      data: { stakeholderTypes },
    }: any = await client.query({
      query: ALL_STAKEHOLDER_TYPES,
      variables: { input: { name: 'Learners' } },
    });

    if (stakeholderTypes) {
      const result = stakeholderTypes.map((a: any) => ({ label: a.name, value: a.id }));
      setAllStakeholderTypes(result);
    }
  };

  useEffect(() => {
    fetchStakeholderTypes();
  }, []);

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...INITIAL_VALUES,
        typeId: allStakeholderTypes[0],
      }}
      onSubmit={async values => {
        const copyOfValues = Object.assign({}, values);
        const formattedValues: any = stripSelectValues(copyOfValues);

        const uploadedData = formattedValues.uploadData.map((b: any) => formatPeopleForBulkUpload(b));

        return await client
          .mutate({
            mutation: CREATE_STAKEHOLDERS,
            variables: {
              inputs: {
                ministryId: formattedValues.ministryId,
                typeId: formattedValues.typeId,
                values: uploadedData,
                updateOrNew: formattedValues.updateOrNew,
                institutionId: props.institutionId,
              },
            },
            refetchQueries: [
              {
                query: props.isAdminPortal ? ALL_PEOPLE_ADMINPORTAL : ALL_PEOPLE,
                variables: { input: { first: 10, status: 'ACTIVE' } },
              },
            ],
          })
          .then(() => 'Success!')
          .catch(e => {
            const msg = parseErrorMessage((e && e.message) || e);
            console.error(msg);
            return msg;
          });
      }}
      render={formikProps => (
        <>
          <UploadPeopleModal
            showPeopleOptionsModal={showPeopleOptionsModal}
            setShowPeopleOptionsModal={setShowPeopleOptionsModal}
            addStakeholderToOrganisation={props.isAdminPortal}
            setShowUploadModal={props.setShowUploadModal}
            showUploadModal={props.showUploadModal}
            isAdminPortal={props.isAdminPortal}
          />
          <TemplateModal
            allStakeholderTypes={allStakeholderTypes}
            formikProps={(formikProps as unknown) as FormikProps<FormikValues>}
            showPeopleOptionsModal={showPeopleOptionsModal}
            setShowPeopleOptionsModal={setShowPeopleOptionsModal}
            institutionId={props.institutionId}
          />
        </>
      )}
    />
  );
};

export default AdminPeopleBulkUpload;
